export interface SubscriptionInfo {
  processorPlan: string;
  status: SubscriptionStatus;
  currentPeriodStart: string;
  currentPeriodEnd: string;
  cancelAtPeriodEnd: boolean;
  standardUserItem?: string;
  studentReportItem?: string;
  aiAssistantItem?: string;
  cancelStudentReportAtPeriodEnd?: boolean;
  cancelAIAssistantAtPeriodEnd?: boolean;
}

export enum SubscriptionStatus {
  ACTIVE = 'active',
  CANCELED = 'canceled',
  PAST_DUE = 'past_due',
  UNPAID = 'unpaid',
  TRIALING = 'trialing',
  INCOMPLETE = 'incomplete',
  INCOMPLETE_EXPIRED = 'incomplete_expired',
}

export enum SubscriptionPlan {
  STANDARD_USER = 'STANDARD_USER',
  STUDENT_REPORT = 'STUDENT_REPORT',
  AI_ASSISTANT = 'AI_ASSISTANT',
}

export enum BaseSubscriptionUsageRecord {
  STANDARD_USER = 3,
  STUDENT_REPORT = 100,
}
